import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import config from '../../../application/config/config';
import Fetch from "../../../core/util/core/Fetch";

import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Col,
} from "reactstrap";
import classnames from "classnames";

import Form from "./Form.js"
import Approvals from "./Tabs/Approvals.js"
import Revenues from "./Tabs/Revenues.js"

function Edit() {
  const [activeTab, setActiveTab] = useState('data');
  const [isLoading, setIsLoading] = useState(true)
  const [formValues, setFormValues] = useState(null)

  const { id } = useParams();

  const paths = {
    endpointGetById: config.endpoints.backend + 'gci/sales/getById'
  }

  useEffect(() => {
    const load = async () => {
      const values = await Fetch.post(paths.endpointGetById, { id })
      setFormValues(values)
      setIsLoading(false)
    }
    load()
  }, [])

  return (
    <div>
      <Nav tabs>
        <NavItem>
          <NavLink
            style={{ cursor: "pointer" }}
            className={classnames({ active: activeTab === 'data' })}
            onClick={() => {
              setActiveTab('data');
            }}
          >
            Dados
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            style={{ cursor: "pointer" }}
            className={classnames({ active: activeTab === 'approvals' })}
            onClick={() => {
              setActiveTab('approvals');
            }}
          >
            Aprovações
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            style={{ cursor: "pointer" }}
            className={classnames({ active: activeTab === 'revenues' })}
            onClick={() => {
              setActiveTab('revenues');
            }}
          >
            Receitas
          </NavLink>
        </NavItem>
      </Nav>
      {
        isLoading ? <p> Carregando.. </p> : (
          <TabContent activeTab={activeTab} className="bg-white">
            <TabPane tabId={'data'}>
              <Col sm="12">
                <Form formValues={formValues} />
              </Col>
            </TabPane>
            <TabPane tabId={'approvals'}>
              <Col sm="12">
                <Approvals formValues={formValues} />
              </Col>
            </TabPane>
            <TabPane tabId={'revenues'}>
              <Col sm="12">
                <Revenues formValues={formValues} />
              </Col>
            </TabPane>
          </TabContent>
        )
      }
    </div>
  );
}
export default Edit;